
import React, { Fragment, FunctionComponent, useContext, useEffect, useLayoutEffect, useState } from "react";
import styles from './Common.module.scss';
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { allTabs, eventEmitter, getToken, getUserId, getUserInfo,getIsLangHdr, getNominatorMail, getUserGraphId } from "./common";
import { Link, useLocation } from "react-router-dom";
import Select from '@material-ui/core/Select';
import { createStyles, FormControl, InputLabel, makeStyles, Menu, MenuProps, styled, Theme, ThemeProvider, useTheme } from "@material-ui/core";
import { LanguagesSupported } from "./constants";
import { UserImage } from "./SearchBox";
import { useDispatch, useSelector } from "react-redux";
import { setChanged } from "../actions/languageActions";
import { store } from '../store/store';
import HomePage from "./HomePage";
import Admin from "./Admin";
import PersonIcon from '@mui/icons-material/Person';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import TranslateIcon from '@mui/icons-material/Translate';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import { getFeatureNames } from "./services";
import { appInsights } from '../AppInsights';
import { useMsal } from '@azure/msal-react';

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 14,
    fontFamily: 'Barlow',
  },
}));

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        // backgroundColor: 'yellow',
      },
    },
  },
}));

const Header: FunctionComponent<any> = () => {
  const location = useLocation();
  const { accounts } = useMsal();
  const account = accounts[0];

  const getcorrelationId = () => {
    return sessionStorage.getItem("correlationId");
  }

  const languageSelected: any = useSelector((state: any) => state.lang);
  const [language, setLanguage] = useState<any>(languageSelected || sessionStorage.getItem("Language") || 'en');
  const [userName, setUserName] = useState<any>(null);

  const [listShow, setListShow] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClickIcon = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  //  const languageSelected:any = useSelector((state:any) => state.lang);
  //const dispatch = useDispatch();

  const handlelanguageChange = (e: any) => {
    setLanguage(e.target.value);
    sessionStorage.setItem("Language",e.target?.value);
    store.dispatch(setChanged(e.target?.value))
    appInsights.trackEvent({ name: "LanguageChanged", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(),  ChangedToLanguage: language } })
  }

  // const handleClickIcon = () => {
  //  setListShow(true);
  // }

  const [token, setToken] = useState<any>(null);
  useEffect(() => {
    getToken().then((token: any) => {
      setToken(token);
    });
  }, [])

  // Keep dropdown in sync with Redux store on every navigation
  useEffect(() => {
    setLanguage(languageSelected);
  }, [languageSelected]);

  const [userId, setUserId] = useState<any>(null);

  useEffect(() => {

    if (token && account) {
      const accountIdentifier = account.localAccountId || account.homeAccountId?.split('.')[0] || '';
      const name = account.name || account.username;
      setUserId(accountIdentifier);
      setUserName(name);
    }

  }, [token, account]);

const classes=useStyles();

  return (
    <div>
      <div className={styles.navBarRow}>
        <img className={styles.NavBrand} src="/logos/ProvidenceLogo.png" />

        <div className={styles.langDiv}>
          <LightTooltip title={"Choose Language"}>
            <IconButton aria-label="delete" className= {classes.root} onClick={handleClickIcon} style={{display:getIsLangHdr()==true?"none":""}}>
              <TranslateIcon fontSize="large"/>
            </IconButton>
          </LightTooltip>
          <Menu
            id="demo-customized-menu"
            MenuListProps={{
              'aria-labelledby': 'demo-customized-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              onChange={handlelanguageChange}
              value={language}
              onClose={handleClose}
              open={open}
            >
              {LanguagesSupported.map((language: any, key: number) => {
                return <MenuItem key={key} value={language.value}>{language.label}</MenuItem>
              })}

            </Select>
          </Menu>
          <LightTooltip
            title={
              userName
            }
          >
            <PersonIcon fontSize="large" className={styles.userInfo} />
          </LightTooltip>

        </div>
      </div>
    </div>
  )
}


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root:{
      "&.MuiIconButton-root":{
      color: "#000000"
    },
    "&.MuiTouchRipple-root":{
      backgroundColor: 'transparent',
    },
    disableRipple: {
      '&:hover': {
        backgroundColor: 'transparent',
      }
    }
  }
  }),
);

export default Header;